module.exports = __webpack_public_path__ + "img/imgjiebtx-2.bcf6e7b7.png";